export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14649.4c6b2aa0.jpg";